import { render, staticRenderFns } from "./DashboardStoreSelect.vue?vue&type=template&id=303fcab2&scoped=true&"
import script from "./DashboardStoreSelect.vue?vue&type=script&lang=js&"
export * from "./DashboardStoreSelect.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStoreSelect.vue?vue&type=style&index=0&id=303fcab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303fcab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
installComponents(component, {VAutocomplete})
